import { InlineErrorMessage } from '@atoms/Errors/InlineErrorMessage';
import { useState } from 'react';
import Select from 'react-select';
import { ErrorMessages } from '@types';

export type SelectOption = {
  label: string;
  value: string;
  isOptionSelected?: boolean;
};

export type CustomSelectProps = {
  options: SelectOption[];
  className?: string;
  title?: string;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  onChange?: (value: SelectOption) => void;
  placeholderText: string | null;
  id: string;
  disabled?: boolean;
  dataTestId?: string;
  /** Optional initial selected value (matched against options[].value). */
  defaultOption?: string;
};

const customClasses = {
  control: (state: any) =>
    `text-body text-text-body bg-ui-form-background border-ui-border max-w-form outline-ui-border w-full rounded-t border p-2 placeholder-current ${state.isFocused ? 'shadow-focus' : ''} ${state.menuIsOpen ? 'border-b-transparent shadow-none' : 'rounded-b'} ${state.isDisabled && 'border-ui-disabled'}`,
  placeholder: (state: any) => `${state.isDisabled && 'text-text-disabled'}`,
  dropdownIndicator: (state: any) => `${state.isDisabled && 'opacity-30'}`,
  menu: () =>
    'text-body bg-ui-form-background rounded-b border border-ui-border shadow py-2 -mt-[1px]',
  option: (state: any) =>
    `text-text-body p-2 hover:bg-ui-border hover:bg-opacity-10 ${state.isFocused ? 'bg-ui-border bg-opacity-10' : ''}`,
};
export const SelectInput = ({
  className = 'capitalize',
  ...props
}: CustomSelectProps) => {
  const [selectedOption, setSelectedOption] = useState<SelectOption | null>(
    props.defaultOption
      ? (props.options.find((option) => option.value === props.defaultOption) ??
          null)
      : null,
  );

  const handleSelect = (value: any) => {
    setSelectedOption(value);
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <div
      className={`max-w-form my-2 w-full ${props.disabled && 'cursor-not-allowed'}`}
    >
      <div
        id={props.id}
        className={`text-bodyLg text-text-body mb-2 font-bold ${props.disabled && 'text-text-disabled'}`}
      >
        {props.title}
      </div>
      <InlineErrorMessage
        path={props.errorPath}
        messages={props.errorMessages}
      />
      <div data-testid={props.dataTestId}>
        <Select
          unstyled
          options={props.options}
          classNames={customClasses}
          value={selectedOption}
          onChange={handleSelect}
          tabSelectsValue={true}
          placeholder={props.placeholderText}
          aria-label={props.id}
          className={className}
          isDisabled={props.disabled}
        />
      </div>
    </div>
  );
};

SelectInput.displayName = 'SelectInput';
